// export const baseUrl = "https://digitalworms.in/api/";
// export const baseUrl = "https://thezivagroup.com/vegas/public/api/";
// export const baseUrl = "https://vegacalibrations.com/vegas/public/api/";
// export const baseUrl = "https://vegacalibrations.com/vegas/vegas/public/api/";
// export const baseUrl = "https://thezivagroup.com/vegas/public/api/";
// export const baseUrl = "https://uniquetechsolution.co.in/vegas/public/api/";
// export const baseUrl = "https://uditsolutions.in/vegas/public/api/";
// export const baseUrl = "https://uditsolutions.in/vega_backend/public/api/";
export const baseUrl = "https://vegacalibration.com/vega_backend/public/api/";
